// Service categories (same as sub-menu items)
export const serviceCategories = [
  'Semua',
  'Konsultasi',
  'Webinar',
  'Dokumen',
  'Legalisasi',
  'Bahasa',
  'Bimbingan Belajar',
  'Pendaftaran',
  "Trip Edukasi"
];

// Function to get all services from markdown files
export async function getServices() {
  try {
    const response = await fetch('/data/services/index.json');
    if (!response.ok) {
      throw new Error('Failed to fetch services index');
    }
    return await response.json();
  } catch (error) {
    console.error('Error loading services:', error);
    return [];
  }
}

// Function to get a single service by ID
export async function getServiceById(id) {
  try {
    const services = await getServices();
    const service = services.find(service => service.id === parseInt(id));
    
    if (!service) {
      throw new Error(`Service with ID ${id} not found`);
    }
    
    const response = await fetch(`/data/services/${service.slug}.md`);
    if (!response.ok) {
      throw new Error(`Failed to fetch service with ID ${id}`);
    }
    
    const content = await response.text();
    return {
      ...service,
      content
    };
  } catch (error) {
    console.error(`Error loading service with ID ${id}:`, error);
    return null;
  }
}

// For backward compatibility, we'll export an empty array as servicesData
// Components should use the async getServices() function instead
export const servicesData = [];